// @ts-nocheck
import React from "react";
import PropTypes from "prop-types";

const illustrations = {
    bird: {
        src: "bird-128.png",
        srcSet: ["bird-128.png 128w", "bird-256.png 256w", "bird-512.png 512w", "bird-1024.png 1024w"],
        srcSetWebp: ["bird-128.webp 128w", "bird-256.webp 256w", "bird-512.webp 512w", "bird-1024.webp 1024w"],
        sizes: "(min-width: 768px) 140px, 60px",
    },

    birdHeron: {
        src: "bird-heron-128.png",
        srcSet: [
            "bird-heron-256.png 128w",
            "bird-heron-256.png 256w",
            "bird-heron-512.png 512w",
            "bird-heron-1024.png 1024w",
        ],
        srcSetWebp: [
            "bird-heron-128.webp 128w",
            "bird-heron-256.webp 256w",
            "bird-heron-512.webp 512w",
            "bird-heron-1024.webp 1024w",
        ],
        sizes: "(min-width: 1024px) 300px, 200px",
    },

    birdSwoosh: {
        src: "bird-swoosh-333.png",
        srcSet: ["bird-swoosh-333.png 333w", "bird-swoosh-665.png 665w", "bird-swoosh-998.png 998w"],
        srcSetWebp: ["bird-swoosh-333.webp 333w", "bird-swoosh-665.webp 665w", "bird-swoosh-998.webp 998w"],
        sizes: "(min-width: 768px) 330px, 260px",
    },

    bull: {
        src: "bull-256.png",
        srcSet: ["bull-256.png 256w", "bull-512.png 512w", "bull-1024.png 1024w"],
        srcSetWebp: ["bull-256.webp 256w", "bull-512.webp 512w", "bull-1024.webp 1024w"],
        sizes: "(min-width: 1024px) 200px, 180px",
    },

    butterfly: {
        src: "butterfly-127.png",
        srcSet: [
            "butterfly-127.png 127w",
            "butterfly-254.png 254w",
            "butterfly-508.png 508w",
            "butterfly-762.png 762w",
        ],
        srcSetWebp: [
            "butterfly-127.webp 127w",
            "butterfly-254.webp 254w",
            "butterfly-508.webp 508w",
            "butterfly-762.webp 762w",
        ],
        sizes: "(min-width: 768px) 100px, 80px",
    },

    capeSticks: {
        src: "cape-and-sticks-238.png",
        srcSet: [
            "cape-and-sticks-238.png 238w",
            "cape-and-sticks-456.png 456w",
            "cape-and-sticks-912.png 912w",
            "cape-and-sticks-1368.png 1368w",
        ],
        srcSetWebp: [
            "cape-and-sticks-238.webp 238w",
            "cape-and-sticks-456.webp 456w",
            "cape-and-sticks-912.webp 912w",
            "cape-and-sticks-1368.webp 1368w",
        ],
        sizes: "(min-width: 768px) 400px, 200px",
    },

    palmPlant: {
        src: "palm-plant-1024.png",
        srcSet: ["palm-plant-1024.png 1024w", "palm-plant-1536.png 1536w", "palm-plant-2048.png 2048w"],
        srcSetWebp: ["palm-plant-1024.webp 1024w", "palm-plant-1536.webp 1536w", "palm-plant-2048.webp 2048w"],
        sizes: "900px",
    },

    happyCloud: {
        src: "happy-cloud-128.png",
        srcSet: ["happy-cloud-128.png 128w", "happy-cloud-256.png 256w", "happy-cloud-512.png 512w"],
        srcSetWebp: ["happy-cloud-128.webp 128w", "happy-cloud-256.webp 256w", "happy-cloud-512.webp 512w"],
        sizes: "150px",
    },

    orangeLeafPeople: {
        src: "orange-leaf-people-512.png",
        srcSet: [
            "orange-leaf-people-256.png 256w",
            "orange-leaf-people-512.png 512w",
            "orange-leaf-people-1024.png 1024w",
        ],
        srcSetWebp: [
            "orange-leaf-people-256.webp 256w",
            "orange-leaf-people-512.webp 512w",
            "orange-leaf-people-1024.webp 1024w",
        ],
        sizes: "383px",
    },

    orangeBird: {
        src: "orange-bird-256.png",
        srcSet: [
            "orange-bird-256.png 256w",
            "orange-bird-512.png 512w",
            "orange-bird-1024.png 1024w",
            "orange-bird-2048.png 2048w",
        ],
        srcSetWebp: [
            "orange-bird-256.webp 256w",
            "orange-bird-512.webp 512w",
            "orange-bird-1024.webp 1024w",
            "orange-bird-2048.webp 2048w",
        ],
        sizes: "353px",
    },

    personCone: {
        src: "scene-person-cone-128.png",
        srcSet: [
            "scene-person-cone-128.png 128w",
            "scene-person-cone-256.png 256w",
            "scene-person-cone-512.png 512w",
            "scene-person-cone-1024.png 1024w",
            "scene-person-cone-2048.png 2048w,",
        ],
        srcSetWebp: [
            "scene-person-cone-128.webp 128w",
            "scene-person-cone-256.webp 256w",
            "scene-person-cone-512.webp 512w",
            "scene-person-cone-1024.webp 1024w",
            "scene-person-cone-2048.webp 2048w,",
        ],
        sizes: "(min-width: 1024px) 456px, 238px",
    },

    palm: {
        src: "palm-512.png",
        srcSet: ["palm-512.png 512w", "palm-1024.png 1024w", "palm-1536.png 1536w", "palm-2048.png 2048w"],
        srcSetWebp: ["palm-512.webp 512w", "palm-1024.webp 1024w", "palm-1536.webp 1536w", "palm-2048.webp 2048w"],
        sizes: "(min-width: 768px) 677px, 407px",
    },

    leafGuard: {
        src: "leaf-guard-128.png",
        srcSet: ["leaf-guard-128.png 128w", "leaf-guard-256.png 256w", "leaf-guard-512.png 512w"],
        srcSetWebp: ["leaf-guard-128.webp 128w", "leaf-guard-256.webp 256w", "leaf-guard-512.webp 512w"],
        sizes: "(min-width: 768px) 365px, 200px",
    },

    stones: {
        src: "stones-128.png",
        srcSet: [
            "stones-128.png 128w",
            "stones-256.png 256w",
            "stones-512.png 512w",
            "stones-1024.png 1024w",
            "stones-2048.png 2048w",
        ],
        srcSetWebp: [
            "stones-128.webp 128w",
            "stones-256.webp 256w",
            "stones-512.webp 512w",
            "stones-1024.webp 1024w",
            "stones-2048.webp 2048w",
        ],
        sizes: "(min-width: 768px) 365px, 200px",
    },

    scenePersonPlant: {
        src: "scene-person-and-plant-1024.png",
        srcSet: [
            "scene-person-and-plant-128.png 128w",
            "scene-person-and-plant-256.png 256w",
            "scene-person-and-plant-512.png 512w",
            "scene-person-and-plant-1024.png 1024w",
            "scene-person-and-plant-2048.png 2048w",
            "scene-person-and-plant-3072.png 3072w",
            "scene-person-and-plant-4096.png 4096w",
        ],
        srcSetWebp: [
            "scene-person-and-plant-128.webp 128w",
            "scene-person-and-plant-256.webp 256w",
            "scene-person-and-plant-512.webp 512w",
            "scene-person-and-plant-1024.webp 1024w",
            "scene-person-and-plant-2048.webp 2048w",
            "scene-person-and-plant-3072.webp 3072w",
            "scene-person-and-plant-4096.webp 4096w",
        ],
        sizes: "(min-width: 768px) 1000px, 600px",
    },

    followSmall: {
        src: "follow-small-128.png",
        srcSet: [
            "follow-small-128.png 128w",
            "follow-small-256.png 256w",
            "follow-small-512.png 512w",
            "follow-small-1024.png 1024w",
        ],
        srcSetWebp: [
            "follow-small-128.webp 128w",
            "follow-small-256.webp 256w",
            "follow-small-512.webp 512w",
            "follow-small-1024.webp 1024w",
        ],
        sizes: "(min-width: 768px) 360px, 200px",
    },

    carriers: {
        src: "carriers-250.png",
        srcSet: ["carriers-125.png 125w", "carriers-250.png 250w", "carriers-500.png 500w", "carriers-1250.png 1250w"],
        srcSetWebp: [
            "carriers-125.webp 125w",
            "carriers-250.webp 250w",
            "carriers-500.webp 500w",
            "carriers-1250.webp 1250w",
        ],
        sizes: "(min-width: 768px) 700px, 320px",
    },

    ladyTalking: {
        src: "scene-lady-talking-128.png",
        srcSet: [
            "scene-lady-talking-128.png 128w",
            "scene-lady-talking-256.png 256w",
            "scene-lady-talking-512.png 512w",
            "scene-lady-talking-1024.png 1024w",
            "scene-lady-talking-2048.png 2048w",
        ],
        srcSetWebp: [
            "scene-lady-talking-128.webp 128w",
            "scene-lady-talking-256.webp 256w",
            "scene-lady-talking-512.webp 512w",
            "scene-lady-talking-1024.webp 1024w",
            "scene-lady-talking-2048.webp 2048w",
        ],
        sizes: "(min-width: 1200px) 1024px, 100vw",
    },

    threeBirds: {
        src: "three-birds-128.png",
        srcSet: [
            "three-birds-128.png 128w",
            "three-birds-256.png 256w",
            "three-birds-512.png 512w",
            "three-birds-1024.png 1024w",
        ],
        srcSetWebp: [
            "three-birds-128.webp 128w",
            "three-birds-256.webp 256w",
            "three-birds-512.webp 512w",
            "three-birds-1024.webp 1024w",
        ],
        sizes: "(min-width: 768px) 600px, 256px",
    },

    predator: {
        src: "predator-261.png",
        srcSet: ["predator-261.png 261w", "predator-522.png 522w", "predator-783.png 783w"],
        srcSetWebp: ["predator-261.webp 261w", "predator-522.webp 522w", "predator-783.webp 783w"],
        sizes: "(min-width: 768px) 260px, 160px",
    },

    clouds: {
        src: "clouds-512.png",
        srcSet: ["clouds-512.png 512w", "clouds-1024.png 1024w"],
        srcSetWebp: ["clouds-512.webp 512w", "clouds-1024.webp 1024w"],
        sizes: "(min-width: 768px) 328px, 200px",
    },

    paperPlane: {
        src: "paper-plane-313.png",
        srcSet: [
            "paper-plane-313.png 313w",
            "paper-plane-626.png 626w",
            "paper-plane-1252.png 1252w",
            "paper-plane-1868.png 1868w",
        ],
        srcSetWebp: [
            "paper-plane-313.webp 313w",
            "paper-plane-626.webp 626w",
            "paper-plane-1252.webp 1252w",
            "paper-plane-1868.webp 1868w",
        ],
        sizes: "(min-width: 1024px) 300px, 200px",
    },

    planeSwoosh: {
        src: "plane-swoosh-213.png",
        srcSet: ["plane-swoosh-213.png 213w", "plane-swoosh-425.png 425w", "plane-swoosh-637.png 637w"],
        srcSetWebp: ["plane-swoosh-213.webp 213w", "plane-swoosh-425.webp 425w", "plane-swoosh-637.webp 637w"],
        sizes: "212px",
    },

    threeFlamingos: {
        src: "three-flamingos-418.png",
        srcSet: ["three-flamingos-418.png 418w", "three-flamingos-836.png 836w", "three-flamingos-1254.png 1254w"],
        srcSetWebp: [
            "three-flamingos-418.webp 418w",
            "three-flamingos-836.webp 836w",
            "three-flamingos-1254.webp 1254w",
        ],
        sizes: "418px",
    },

    sceneLittlePeopleWithRocks: {
        src: "scene-little-people-with-rocks-850.png",
        srcSet: [
            "scene-little-people-with-rocks-850.png 850w",
            "scene-little-people-with-rocks-1024.png 1024w",
            "scene-little-people-with-rocks-2048.png 2048w",
            "scene-little-people-with-rocks-3072.png 3072w",
        ],
        srcSetWebp: [
            "scene-little-people-with-rocks-850.webp 850w",
            "scene-little-people-with-rocks-1024.webp 1024w",
            "scene-little-people-with-rocks-2048.webp 2048w",
            "scene-little-people-with-rocks-3072.webp 3072w",
        ],
        sizes: "850px",
    },

    sceneBuildingPlans: {
        src: "building-plans-704.png",
        srcSet: [
            "building-plans-704.png 704w",
            "building-plans-1408.png 1408w",
            "building-plans-2112.png 2112w",
            "building-plans-3297.png 3297w",
        ],
        srcSetWebp: [
            "building-plans-704.webp 704w",
            "building-plans-1408.webp 1408w",
            "building-plans-2112.webp 2112w",
            "building-plans-3297.webp 3297w",
        ],
        sizes: "850px",
    },

    dizzyPeopleOnStone: {
        src: "dizzy-people-on-stone-256.png",
        srcSet: [
            "dizzy-people-on-stone-256.png 256w",
            "dizzy-people-on-stone-512.png 512w",
            "dizzy-people-on-stone-1024.png 1024w",
        ],
        srcSetWebp: [
            "dizzy-people-on-stone-256.webp 256w",
            "dizzy-people-on-stone-512.webp 512w",
            "dizzy-people-on-stone-1024.webp 1024w",
        ],
        sizes: "(min-width: 1024px) 518px, 300px",
    },

    carryingButtonsFourPeople: {
        src: "carrying-buttons-4-people-256.png",
        srcSet: [
            "carrying-buttons-4-people-256.png 256w",
            "carrying-buttons-4-people-512.png 512w",
            "carrying-buttons-4-people-1024.png 1024w",
            "carrying-buttons-4-people-2048.png 2048w,",
        ],
        srcSetWebp: [
            "carrying-buttons-4-people-256.webp 256w",
            "carrying-buttons-4-people-512.webp 512w",
            "carrying-buttons-4-people-1024.webp 1024w",
            "carrying-buttons-4-people-2048.webp 2048w,",
        ],
        sizes: "(min-width: 1024px) 518px, 300px",
    },

    walkingAlone: {
        src: "walking-alone-256.png",
        srcSet: ["walking-alone-256.png 256w", "walking-alone-512.png 512w", "walking-alone-1024.png 1024w"],
        srcSetWebp: ["walking-alone-256.webp 256w", "walking-alone-512.webp 512w", "walking-alone-1024.webp 1024w"],
        sizes: "(min-width: 1024px) 518px, 300px",
    },

    mountains: {
        src: "mountains-1024.png",
        srcSet: [
            "mountains-1024.png 1024w",
            "mountains-2048.png 2048w",
            "mountains-3072.png 3072w",
            "mountains-4096.png 4096w",
        ],
        srcSetWebp: [
            "mountains-1024.webp 1024w",
            "mountains-2048.webp 2048w",
            "mountains-3072.webp 3072w",
            "mountains-4096.webp 4096w",
        ],
    },

    flockBirds: {
        src: "flock-of-birds-364.png",
        srcSet: [
            "flock-of-birds-364.png 364w",
            "flock-of-birds-592.png 592w",
            "flock-of-birds-1184.png 1184w",
            "flock-of-birds-1776.png 1776w",
        ],
        srcSetWebp: [
            "flock-of-birds-364.webp 364w",
            "flock-of-birds-592.webp 592w",
            "flock-of-birds-1184.webp 1184w",
            "flock-of-birds-1776.webp 1776w",
        ],
        sizes: "(min-width: 768px) 400px, 200px",
    },

    stackedHead: {
        src: "stacked-head-and-animal-256.png",
        srcSet: [
            "stacked-head-and-animal-128.png 128w",
            "stacked-head-and-animal-256.png 256w",
            "stacked-head-and-animal-512.png 512w",
            "stacked-head-and-animal-1024.png 1024w",
        ],
        srcSetWebp: [
            "stacked-head-and-animal-128.webp 128w",
            "stacked-head-and-animal-256.webp 256w",
            "stacked-head-and-animal-512.webp 512w",
            "stacked-head-and-animal-1024.webp 1024w",
        ],
        sizes: "(min-width: 1024px) 220px, 160px",
    },

    sceneIwoJima: {
        src: "scene-iwo-jima-256.png",
        srcSet: [
            "scene-iwo-jima-256.png 256w",
            "scene-iwo-jima-512.png 512w",
            "scene-iwo-jima-1024.png 1024w",
            "scene-iwo-jima-2048.png 2048w",
        ],
        srcSetWebp: [
            "scene-iwo-jima-256.webp 256w",
            "scene-iwo-jima-512.webp 512w",
            "scene-iwo-jima-1024.webp 1024w",
            "scene-iwo-jima-2048.webp 2048w",
        ],
        sizes: "(min-width: 1200px) 600px, 512px",
    },

    walkingBird: {
        src: "walking-bird-2-128.png",
        srcSet: [
            "walking-bird-2-128.png 128w",
            "walking-bird-2-256.png 256w",
            "walking-bird-2-512.png 512w",
            "walking-bird-2-1024.png 1024w",
        ],
        srcSetWebp: [
            "walking-bird-2-128.webp 128w",
            "walking-bird-2-256.webp 256w",
            "walking-bird-2-512.webp 512w",
            "walking-bird-2-1024.webp 1024w",
        ],
        sizes: "128px",
    },

    flyingFlamingos: {
        src: "flying-flamingos-219.png",
        srcSet: ["flying-flamingos-219.png 219w", "flying-flamingos-437.png 437w", "flying-flamingos-874.png 874w"],
        srcSetWebp: [
            "flying-flamingos-219.webp 219w",
            "flying-flamingos-437.webp 437w",
            "flying-flamingos-874.webp 874w",
        ],
        sizes: "219px",
    },

    yellowBird: {
        src: "yellow-bird-128.png",
        srcSet: ["yellow-bird-128.png 128w", "yellow-bird-256.png 256w", "yellow-bird-512.png 512w"],
        srcSetWebp: ["yellow-bird-128.webp 128w", "yellow-bird-256.webp 256w", "yellow-bird-512.webp 512w"],
        sizes: "(min-width: 1024px) 200px, 100px",
    },

    launchingBird: {
        src: "launching-bird-256.png",
        srcSet: ["launching-bird-256.png 256w", "launching-bird-512.png 512w", "launching-bird-1024.png 1024w"],
        srcSetWebp: ["launching-bird-256.webp 256w", "launching-bird-512.webp 512w", "launching-bird-1024.webp 1024w"],
        sizes: "244px",
    },

    centipede: {
        src: "centipede-184.png",
        srcSet: ["centipede-184.png 184w", "centipede-368.png 368w", "centipede-552.png 552w"],
        srcSetWebp: ["centipede-184.webp 184w", "centipede-368.webp 368w", "centipede-552.webp 552w"],
        sizes: "184px",
    },

    birdSwirl: {
        src: "bird-with-swirl-128.png",
        srcSet: ["bird-with-swirl-128.png 184w", "bird-with-swirl-338.png 368w"],
        srcSetWebp: ["bird-with-swirl-128.webp 184w", "bird-with-swirl-338.webp 368w"],
        sizes: "338px",
    },

    swoosh: {
        src: "swoosh-293.png",
        srcSet: ["swoosh-293.png 293w"],
        srcSetWebp: ["swoosh-293.webp 293w"],
        sizes: "293px",
    },

    manModelPlane: {
        src: "man-and-model-plane-128.png",
        srcSet: [
            "man-and-model-plane-128.png 128w",
            "man-and-model-plane-256.png 256w",
            "man-and-model-plane-512.png 512w",
        ],
        srcSetWebp: [
            "man-and-model-plane-128.webp 128w",
            "man-and-model-plane-256.webp 256w",
            "man-and-model-plane-512.webp 512w",
        ],
        sizes: "400px",
    },

    paperPlanePink: {
        src: "paper-plane-pink-330.png",
        srcSet: ["paper-plane-pink-330 330w"],
        srcSetWebp: ["paper-plane-pink-330.webp 330w"],
        sizes: "330px",
    },

    riders: {
        src: "riders-342.png",
        srcSet: ["riders-342.png 342w"],
        srcSetWebp: ["riders-342.webp 342w"],
        sizes: "342px",
    },

    paperPerson: {
        src: "paper-person-115.png",
        srcSet: ["paper-person-115.png 115w", "paper-person-230.png 230w", "paper-person-345.png 345w"],
        srcSetWebp: ["paper-person-115.webp 115w", "paper-person-230.webp 230w", "paper-person-345.webp 345w"],
        sizes: "(min-width: 768px) 115px, 95px",
    },

    butterflySwirl: {
        src: "butterfly-swirl-216.png",
        srcSet: ["butterfly-swirl-216.png 216w"],
        srcSetWebp: ["butterfly-swirl-216.webp 216w"],
        sizes: "216px",
    },

    birdOutline: {
        src: "flying-bird-outline-221.png",
        srcSet: ["flying-bird-outline-221.png 221w"],
        srcSetWebp: ["flying-bird-outline-221.webp 221w"],
        sizes: "221px",
    },

    rocks: {
        src: "rocks-308.png",
        srcSet: ["rocks-308.png 308w"],
        srcSetWebp: ["rocks-308.webp 308w"],
        sizes: "308px",
    },

    planeSmall: {
        src: "plane-small-202.png",
        srcSet: ["plane-small-202.png 202w"],
        srcSetWebp: ["plane-small-202.webp 202w"],
        sizes: "202px",
    },

    butterflyMiniSwirl: {
        src: "butterfly-mini-swirl-188.png",
        srcSet: ["butterfly-mini-swirl-188.png 188w"],
        srcSetWebp: ["butterfly-mini-swirl-188.webp 188w"],
        sizes: "188px",
    },

    planeYellow: {
        src: "plane-yellow-189.png",
        srcSet: ["plane-yellow-189.png 189w"],
        srcSetWebp: ["plane-yellow-189.webp 189w"],
        sizes: "189px",
    },

    centipedeSwoosh: {
        src: "centipede-swoosh-258.png",
        srcSet: ["centipede-swoosh-258.png 258w"],
        srcSetWebp: ["centipede-swoosh-258.webp 258w"],
        sizes: "258px",
    },

    swirl: {
        src: "swirl-232.png",
        srcSet: ["swirl-232.png 232w"],
        srcSetWebp: ["swirl-232.webp 232w"],
        sizes: "232px",
    },
};

export default function Illustration({ alt, className, variant }) {
    if (!(variant in illustrations)) {
        return null;
    }

    const illustrationsPath = `${__PATH_PREFIX__}/assets/illustrations`;
    const src = illustrations[variant].src;
    const srcSet = illustrations[variant].srcSet.map((src) => `${illustrationsPath}/${src}`).join(", ");
    const srcSetWebp = illustrations[variant].srcSetWebp.map((src) => `${illustrationsPath}/${src}`).join(", ");

    const sizes = illustrations[variant].sizes;

    return (
        <picture>
            <source sizes={sizes} type={"image/png"} srcSet={srcSet} />
            <source sizes={sizes} type={"image/webp"} srcSet={srcSetWebp} />
            <img alt={alt} src={`${illustrationsPath}/${src}`} loading={"lazy"} className={className} />
        </picture>
    );
}

Illustration.propTypes = {
    alt: PropTypes.string,
    className: PropTypes.string,
    variant: PropTypes.oneOf(Object.keys(illustrations)).isRequired,
};
